import enUtilsLocaleFile from "@payping/utils/locales/en.json";
import faUtilsLocaleFile from "@payping/utils/locales/fa.json";
import { localeNameSpaces } from "@payping/utils/localeUtils";
import enComponentsLocaleFile from "@payping/web-components/locales/i18next_en.json";
import faComponentsLocaleFile from "@payping/web-components/locales/i18next_fa.json";

import enWrapperLocaleFile from "./en.json";
import faWrapperLocaleFile from "./fa.json";

type Locales = "en" | "fa";
type Namespaces = string;
type LocaleFile = Record<string, unknown>;
type NamespaceDefinition = Record<Namespaces, LocaleFile>;
type LocaleResources = Record<Locales, NamespaceDefinition>;

export const localeResources: LocaleResources = {
  en: {
    [localeNameSpaces[localeNameSpaces.Wrapper]]: enWrapperLocaleFile,
    [localeNameSpaces[localeNameSpaces.Utils]]: enUtilsLocaleFile,
    [localeNameSpaces[localeNameSpaces.Components]]: enComponentsLocaleFile,
  },
  fa: {
    [localeNameSpaces[localeNameSpaces.Wrapper]]: faWrapperLocaleFile,
    [localeNameSpaces[localeNameSpaces.Utils]]: faUtilsLocaleFile,
    [localeNameSpaces[localeNameSpaces.Components]]: faComponentsLocaleFile,
  },
};
